import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "remixicon/fonts/remixicon.css";

const DischargeAdviceForm = ({ formData, setFormData, handleChange, isLoading }) => {
  // const reasons = [
  //   "Rehab goals achieved to the desired level.",
  //   "Discharge against medical advice (Family’s insistence)",
  //   "Resistant to Rehab interventions.",
  //   "Any medical condition/emergency.",
  //   "Other",
  // ];

  return (
    <div className="p-4">
      {/* === CLIENT INFO === */}
      <div className="row mb-3">
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
          Client Information
        </small>

        {[
          { name: "clientName", label: "Client’s Name" },
          { name: "assignedPRP", label: "Assigned PRP" },
          { name: "psychiatricDiagnosis", label: "Psychiatric Diagnosis" },
          { name: "primaryCaretaker", label: "Primary Caretaker" },
        ].map((item) => (
          <div className="col-md-4" key={item.name}>
            <div className="form-floating form-floating-outline mb-3">
              <input
                type="text"
                name={item.name}
                className="form-control"
                value={formData[item.name] || ""}
                onChange={handleChange}
                placeholder={item.label}
                disabled={isLoading}
                readOnly={item.name === "clientName" && (!!formData.patientId || !!formData.patient_id)}
              />
              <label>{item.label}</label>
            </div>
          </div>
        ))}

        <div className="col-md-4">
          <div className="form-floating form-floating-outline mb-3">
            <input
              type="date"
              name="admissionDate"
              className="form-control"
              value={formData.admissionDate || ""}
              onChange={handleChange}
              disabled={isLoading}
            />
            <label>Date of Admission</label>
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-floating form-floating-outline mb-3">
            <input
              type="date"
              name="dischargeDate"
              className="form-control"
              value={formData.dischargeDate || ""}
              onChange={handleChange}
              disabled={isLoading}
            />
            <label>Date of Discharge</label>
          </div>
        </div>
      </div>

      {/* === REASONS FOR DISCHARGE === */}
      {/* <div className="row mb-4">
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
          Reasons for Discharge
        </small>

        <div className="row g-3">
          {reasons.map((option, index) => {
            const id = `reason-${index}`;
            const isOther = option === "Other";
            return (
              <div
                key={id}
                className={`col-md-${isOther ? "6" : "6"} col-lg-4 d-flex align-items-start`}
              >
                <div className="form-check w-100">
                  <input
                    type="radio"
                    id={id}
                    name="dischargeReason"
                    className="form-check-input"
                    value={option}
                    checked={formData.dischargeReason === option}
                    onChange={handleChange}
                    disabled={isLoading}
                  />
                  <label
                    htmlFor={id}
                    className="form-check-label ms-1"
                    style={{ cursor: "pointer" }}
                  >
                    {option}
                  </label>

                  {isOther && formData.dischargeReason === "Other" && (
                    <div className="form-floating form-floating-outline mt-2 w-100">
                      <input
                        type="text"
                        name="otherReason"
                        className="form-control"
                        placeholder="Specify reason"
                        value={formData.otherReason || ""}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                      <label>Specify other reason</label>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div> */}

      {/* === REMARKS === */}
      <div className="row mb-4">
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
          Reason Of Discharge
        </small>
        <div className="col-md-12">
          <div className="form-floating form-floating-outline mb-3">
            <textarea
              name="dischargeReason"
              className="form-control"
              placeholder="Remarks by Director"
              style={{ height: "100px" }}
              value={formData.dischargeReason || ""}
              onChange={handleChange}
              disabled={isLoading}
            />
            <label>By Director</label>
          </div>
        </div>
      </div>

      {/* === DOCUMENT FOOTER === */}
      <div className="row mb-4">
        <div className="col-md-4">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              name="documentName"
              className="form-control"
              value={formData.documentName}
              readOnly
            />
            <label>Document Name</label>
          </div>
        </div>

        <div className="col-md-4"></div>

        <div className="col-md-4">
          <div className="form-floating form-floating-outline">
            <input
              type="date"
              name="effectiveDate"
              className="form-control"
              value={formData.effectiveDate || ""}
              onChange={handleChange}
              disabled={isLoading}
            />
            <label>Effective Date</label>
          </div>
        </div>
      </div>

      <div className="row g-3">
        <div className="col-md-3">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              name="approvedBy"
              className="form-control"
              value={formData.approvedBy || ""}
              onChange={handleChange}
              disabled={isLoading}
            />
            <label>Approved By</label>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-floating form-floating-outline">
            <input
              type="date"
              name="approvedDate"
              className="form-control"
              value={formData.approvedDate || ""}
              onChange={handleChange}
              disabled={isLoading}
            />
            <label>Date</label>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              name="nextRevisionBy"
              className="form-control"
              value={formData.nextRevisionBy || ""}
              onChange={handleChange}
              disabled={isLoading}
            />
            <label>Next Revision By</label>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-floating form-floating-outline">
            <input
              type="date"
              name="nextRevisionDate"
              className="form-control"
              value={formData.nextRevisionDate || ""}
              onChange={handleChange}
              disabled={isLoading}
            />
            <label>Date</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DischargeAdviceForm;